<template>
  <div>
    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
      <base-alert v-if="errors.length" type="danger">
        <b>You have the following error(s):</b>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </base-alert>

      <div v-if="formId == 'addCategory'">
        <h6 class="heading-small text-muted mb-4">Add Sub-Category</h6>
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <!-- {{categoryName}} -->
              <base-input alternative="" label="Name" placeholder="" v-model="categoryName"
                input-classes="form-control" />
              <!-- {{categoryCode}} -->
              <base-input alternative="" label="Code" placeholder="" v-model="categoryCode"
                input-classes="form-control" />
              <base-input alternative="" label="Reference Code" placeholder="" v-model="categoryRefCode"
                input-classes="form-control" />
              <base-input alternative="" label="Remark">
                <textarea v-model="categoryRemark" rows="4" class="form-control" />
              </base-input>
              <base-input label="Sequence No">
                <a-input type="number" v-model="categorySequenceNo" />
              </base-input>
            </a-tab-pane>
            <a-tab-pane v-if="categoryLevel == 4" tab="Category Settings" key="2">
              <dynamic-form :convertedJson="convertedJson" @valueUpdated="updateSettings"></dynamic-form>
            </a-tab-pane>
          </a-tabs>

          <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn btn-success" @click.prevent="createData">Create</button>
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>

      <div v-if="formId == 'editCategory'">
        <h6 class="heading-small text-muted mb-4">Edit Category</h6>
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <base-input alternative="" label="Name" placeholder="" v-model="categoryName"
                input-classes="form-control" />
              <base-input alternative="" label="Code" placeholder="" v-model="categoryCode"
                input-classes="form-control" />
              <base-input alternative="" label="Reference Code" placeholder="" v-model="categoryRefCode"
                input-classes="form-control" />
              <base-input alternative="" label="Remark">
                <textarea v-model="categoryRemark" rows="4" class="form-control" />
              </base-input>
              <base-input label="Sequence No">
                <a-input type="number" v-model="categorySequenceNo" />
              </base-input>
            </a-tab-pane>

            <a-tab-pane v-if="categoryLevel == 4" tab="Category Settings" key="2">
              <dynamic-form :key="componentKey" :convertedJson="convertedJson" :formSettings="formSettings"
                @valueUpdated="updateSettings"></dynamic-form>
            </a-tab-pane>
          </a-tabs>

          <div v-if="serverType == 'ho'" class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn btn-success" @click.prevent="updateData">Update</button>
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>

          <div v-else class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>

         <div v-if="formId == 'viewCategory'">
        <h6 class="heading-small text-muted mb-4">View Category</h6>
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <base-input alternative="" label="Name" placeholder="" v-model="categoryName"
                input-classes="form-control" :disabled="viewMode"/>
              <base-input alternative="" label="Code" placeholder="" v-model="categoryCode"
                input-classes="form-control" :disabled="viewMode"/>
              <base-input alternative="" label="Reference Code" placeholder="" v-model="categoryRefCode"
                input-classes="form-control" :disabled="viewMode"/>
              <base-input alternative="" label="Remark">
                <textarea v-model="categoryRemark" rows="4" class="form-control" :disabled="viewMode"/>
              </base-input>
              <base-input label="Sequence No">
                <a-input type="number" v-model="categorySequenceNo" :disabled="viewMode"/>
              </base-input>
            </a-tab-pane>

            <a-tab-pane v-if="categoryLevel == 4" tab="Category Settings" key="2">
              <dynamic-form :key="componentKey" :convertedJson="convertedJson" :formSettings="formSettings"
                @valueUpdated="updateSettings" :disabled="viewMode"></dynamic-form>
            </a-tab-pane>
          </a-tabs>

          <div v-if="serverType == 'ho'" class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
          
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>

          <div v-else class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>

      <div v-if="formId == 'editOptionGroup'">
        <h6 class="heading-small text-muted mb-4">Edit Option Group</h6>
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <base-input label="Code">
                <a-input type="text" autocomplete="off" v-model="prdoptgrp.code" input-classes="form-control"
                  required />
              </base-input>
              <base-input label="Name" required>
                <a-input type="text" autocomplete="off" v-model="prdoptgrp.name" input-classes="form-control"
                  required />
              </base-input>
              <base-input label="Sequence No" required>
                <a-input type="number" v-model="prdoptgrp.sequence_no" />
              </base-input>
            </a-tab-pane>
          </a-tabs>

          <div v-if="serverType == 'ho'" class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn btn-success" @click.prevent="updateOptionGroup">Update</button>
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>

          <div v-else class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>
      <div v-if="formId == 'editOption' || formId == 'addOption'">
        <h6 class="heading-small text-muted mb-4" v-if="formId == 'editOption'">Edit Option</h6>
        <h6 class="heading-small text-muted mb-4" v-else>Add Option</h6>
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <a-input-group compact v-if="formId == 'addOption'">
                <a-select v-model="searchFilter" style="width: 25%" size="large">
                  <a-select-option @click="changeSearchFilter('Name')" value="name">Name</a-select-option>
                  <a-select-option @click="changeSearchFilter('Barcode')" value="barcode">Barcode</a-select-option>
                  <a-select-option @click="changeSearchFilter('Stock Number')" value="stock_no">Stock No.
                  </a-select-option>
                  <a-select-option @click="changeSearchFilter('Reference Code')" value="reference_code">Ref. Code
                  </a-select-option>
                </a-select>
                <autocomplete style="width: 75%;" ref="autocomplete" :placeholder="placeholder"
                  :source="productEndpoint" input-class="form-control autocomplete-customs" results-property="data"
                  :results-display="formattedDisplay" :request-headers="authHeaders" @selected="getProduct"
                  @clear="clearProduct">
                </autocomplete>
              </a-input-group>
              <hr v-if="formId == 'addOption'" />
              <base-input label="Code" required>
                <a-input type="text" v-model="prdopt.code" input-classes="form-control" disabled />
              </base-input>
              <base-input label="Name" required>
                <a-input type="text" v-model="prdopt.name" input-classes="form-control" disabled />
              </base-input>

              <!-- <base-input alternative="" label="Code" placeholder="" v-model="prdopt.code" input-classes="form-control" readonly/>
          <base-input alternative="" label="Name" placeholder="" v-model="prdopt.name" input-classes="form-control" readonly required/> -->
              <base-input label="Product Option Group" required>
                <a-select v-model="prdopt.product_option_group_id" showSearch placeholder="Select Product Option Group"
                  optionFilterProp="children" style="width: 100%" :filterOption="true" disabled>
                  <a-select-option v-for="option in prodoptgrp" :key="option.id" :value="option.id">{{ option.code }} -
                    {{ option.name }}</a-select-option>
                </a-select>
              </base-input>
              <base-input label="Sequence No" required>
                <a-input type="number" v-model="prdopt.sequence_no" />
              </base-input>
            </a-tab-pane>
          </a-tabs>

          <div v-if="serverType == 'ho'" class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn btn-success" @click.prevent="updateOption" v-if="formId == 'editOption'">Update</button>
            <button class="btn btn-success" @click.prevent="addOption" v-else>Add</button>
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>

          <div v-else class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>

      <div v-if="formId == 'editComboGroup' || formId == 'addComboGroup'">
        <h6 class="heading-small text-muted mb-4" v-if="formId == 'editComboGroup'">Edit Combo Group</h6>
        <h6 class="heading-small text-muted mb-4" v-else>Add Combo Group</h6>
        <form id="form-proper">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Basic" key="1">
              <base-input label="Name" required>
                <a-input type="text" v-model="prdcmbgrp.name" input-classes="form-control" />
              </base-input>
              <base-input label="Reference Code">
                <a-input type="string" v-model="prdcmbgrp.reference_code" />
              </base-input>
              <base-input label="Card Type">
                <a-select
                  showSearch
                  v-model="prdcmbgrp.card_type_id"
                  style="width: 100%"
                  placeholder="Please select"
                  :filterOption="false"
                  :notFoundContent="fetchingCardTypes ? undefined : null"
                  @search="fetchSupercardTypes"
                  @focus="fetchSupercardTypes()"
                >
                  <a-spin v-if="fetchingCardTypes" slot="notFoundContent" size="small" />
                  <a-select-option v-for="option in supercardTypes" :key="option.id" :value="option.id">
                    {{ option.name }}
                  </a-select-option>
                </a-select>
              </base-input>
              <base-input label="Product" required>
                <!-- <a-input type="number" v-model="prdcmbgrp.product_id" /> -->
                <a-select v-model="prdcmbgrp.product_id" show-search @search="handleProductSearch">
                  <a-select-option v-for="product in productSearchList" :key="product.id" :value="product.id">
                    {{ product.name }} ({{ product.id }})
                  </a-select-option>
                </a-select>
              </base-input>
              <base-input label="Combo Value Link">
                <small class="d-block mt--1 mb-2">Enable the combo group only when this combo value is selected.</small>
                <a-cascader v-model="prdcmbgrp.combo_value_link_arr" :options="comboValueCascade" />
              </base-input>
              <base-input label="Sequence No" required>
                <a-input type="number" v-model="prdcmbgrp.sequence_no" />
              </base-input>
              <base-input label="Option Type" required class="d-flex justify-content-between align-items-center">
                <a-radio-group v-model="prdcmbgrp.option_type" button-style="solid">
                  <a-radio-button value="single">Single Product</a-radio-button>
                  <a-radio-button value="multiple">Multiple</a-radio-button>
                  <a-radio-button value="option">Option</a-radio-button>
                </a-radio-group>
              </base-input>
              <base-input label="Status" required class="d-flex justify-content-between align-items-center">
                <a-radio-group v-model="prdcmbgrp.status" button-style="solid">
                  <a-radio-button value="A" defaultChecked>Active</a-radio-button>
                  <a-radio-button value="I">Inactive</a-radio-button>
                </a-radio-group>
              </base-input>
              <base-input label="Required" required class="d-flex justify-content-between align-items-center">
                <a-switch v-model="prdcmbgrp.is_required" />
              </base-input>
              <base-input label="Freebie" required class="d-flex justify-content-between align-items-center mb-5">
                <a-switch v-model="prdcmbgrp.is_freebie" />
              </base-input>
            </a-tab-pane>
          </a-tabs>

          <div v-if="serverType == 'ho'" class="float-right" style="position: absolute; bottom: 0px; right: 0px; width: -webkit-fill-available;background-color: #f2f2f2; padding: 10px;">
            <button class="btn btn-success float-right mx-1" @click.prevent="updateComboGroup"
              v-if="formId == 'editComboGroup'">Update</button>
            <button class="btn btn-success float-right mx-1" @click.prevent="addComboGroup" v-else>Add</button>
            <button class="btn btn-primary float-right mx-1" @click.prevent="onClose">Cancel</button>
          </div>

          <div v-else class="float-right" style="position: absolute; bottom: 0px; right: 0px; width: -webkit-fill-available;background-color: #f2f2f2; padding: 10px;">
            <button class="btn btn-primary float-right" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>

      <div v-if="formId == 'editCombo' || formId == 'addCombo'">
        <h6 class="heading-small text-muted mb-4" v-if="formId == 'editCombo'">Edit Combo</h6>
        <h6 class="heading-small text-muted mb-4" v-else>Add Combo</h6>
        <form id="form-proper">
          <a-input-group compact v-if="formId == 'addCombo'">
            <a-select v-model="searchFilter" style="width: 25%" size="large">
              <a-select-option @click="changeSearchFilter('Name')" value="name">Name</a-select-option>
              <a-select-option @click="changeSearchFilter('Barcode')" value="barcode">Barcode</a-select-option>
              <a-select-option @click="changeSearchFilter('Stock Number')" value="stock_no">Stock No.
              </a-select-option>
              <a-select-option @click="changeSearchFilter('Reference Code')" value="reference_code">Ref. Code
              </a-select-option>
            </a-select>
            <autocomplete style="width: 75%;" ref="autocomplete" :placeholder="placeholder"
              :source="productEndpoint" input-class="form-control autocomplete-customs" results-property="data"
              :results-display="formattedDisplay" :request-headers="authHeaders" @selected="getProductCombo"
              @clear="clearProductCombo">
            </autocomplete>
          </a-input-group>
          <hr v-if="formId == 'addCombo'" />
          <!-- <base-input alternative="" label="Product Barcode" placeholder="" v-model="prdcmb.product_code"
            input-classes="form-control" required readonly /> -->
          <base-input alternative="" label="Name" placeholder="" v-model="prdcmb.name" input-classes="form-control" required />
          <base-input label="Reference Code" v-model="prdcmb.reference_code" />
          <base-input label="Description">
            <textarea
              v-model="prdcmb.description"
              rows="4"
              class="form-control"
              style="resize:none;"
            />
          </base-input>
          <base-input type="number" min="0" label="Price" v-model="prdcmb.price" name="price" required />
          <base-input label="Product Combo Group" required>
            <a-select v-model="prdcmb.product_combo_group_id" showSearch placeholder="Select Product Combo Group"
              optionFilterProp="children" style="width: 100%" :filterOption="true" disabled>
              <a-select-option v-for="option in prodcmbgrp" :key="option.id" :value="option.id">{{ option.code }} - {{ option.name }}</a-select-option>
            </a-select>
          </base-input>
          <base-input label="Sequence No" required>
            <a-input type="number" v-model="prdcmb.sequence_no" />
          </base-input>
          <base-input label="Minimum Quantity" required>
            <a-input type="number" v-model="prdcmb.min_qty" />
          </base-input>
          <base-input label="Maximum Quantity" required>
            <a-input type="number" v-model="prdcmb.max_qty" />
          </base-input>
          <base-input label="Status" required class="d-flex justify-content-between align-items-center mb-5">
            <a-radio-group v-model="prdcmb.status" button-style="solid">
              <a-radio-button value="A" defaultChecked>Active</a-radio-button>
              <a-radio-button value="I">Inactive</a-radio-button>
            </a-radio-group>
          </base-input>

          <div v-if="serverType == 'ho'" class="float-right" style="position: absolute; bottom: 0px; right: 0px; width: -webkit-fill-available;background-color: #f2f2f2; padding: 10px; z-index: 7;">
            <button class="btn btn-success float-right mx-1" @click.prevent="updateCombo" v-if="formId == 'editCombo'">Update</button>
            <button class="btn btn-success float-right mx-1" @click.prevent="addCombo" v-else>Add</button>
            <button class="btn btn-primary float-right mx-1" @click.prevent="onClose">Cancel</button>
          </div>

          <div v-else class="float-right" style="position: absolute; bottom: 0px; right: 0px; width: -webkit-fill-available;background-color: #f2f2f2; padding: 10px;">
            <button class="btn btn-primary float-right" @click.prevent="onClose">Cancel</button>
          </div>
        </form>
      </div>
    </a-drawer>

    <!-- history drawer -->
    <a-drawer title="" :width="800" placement="right" @close="onClose" :visible="historyVisible">
      <div>
        <h6 class="heading-small text-muted mb-4 text-truncate">Category Action History</h6>
        <a-table :columns="historyColumns" :dataSource="historyData" size="small"  />
      </div>
    </a-drawer>

    <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
      <base-dropdown v-if="activeModules.length > 0">
        <base-button slot="title" type="success" class="dropdown-toggle">
          {{ _.startCase(currentProfile) }}
        </base-button>
        <a v-for="profile in activeModules" :key="profile.id"
          @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)" class="dropdown-item"
          href="#">{{ profile.name }}</a>
      </base-dropdown>
      <base-dropdown v-else>
        <base-button slot="title" type="success" class="dropdown-toggle">
          Product Profiles
        </base-button>
        <a class="dropdown-item" disabled>No active module/s under this feature</a>
        <!-- <a v-for="profile in activeModules" :key="profile.id" @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)))" class="dropdown-item" href="#">{{profile.name}}</a> -->
      </base-dropdown>
    </base-header>

    <div class="container-fluid mt--7">

      <div v-if="currentProfile == 'categories'" class="card mb-3">
        <a-spin :spinning="spinning">
          <div class="card shadow" style="min-height: 100%">
            <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
              <div class="row align-items-center">
                <div class="col-md-12"> Manage Categories </div>
                <div class="col-md-10"><small>Set how products are sorted using nested groups</small></div>
                <div class="col-md-2">
                  <base-dropdown class="nav-link pr-0 float-right" position="right">
                    <div class="media align-items-center" slot="title">
                      <i class="fa fa-ellipsis-v float-right btn-sm"></i>
                    </div>
                    <template>
                      <div class=" dropdown-header noti-title">
                        <h6 class="text-overflow m-0">ACTIONS</h6>
                      </div>
                      <div v-if="accessRights.includes('E')" class="dropdown-item" @click.prevent="downloadCategories">
                        <i class="fa fa-download"></i>
                        <span>Export Categories</span>
                      </div>
                    </template>
                  </base-dropdown>
                </div>
                <div class="col-md-12"><br></div>
                <div class="col-md-3 col-sm-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                      <div class="row">
                        <div class="col-md-8">DIVISION</div>
                        <div v-if="accessRights.includes('A')" class="col-md-4 float-right">
                          <base-button class="float-right ml-1" type="primary" size="sm"
                            @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus" />
                          </base-button>
                        </div>
                      </div>
                    </li>

                    <div style="height: 545px; overflow-y: auto;">
                      <li class="list-group-item" style="font-size: 14px;"><span class="fa fa-lock" /> &nbsp; All
                        Products</li>
                      <li class="list-group-item" style="font-size: 14px"><span class="fa fa-lock" /> &nbsp;
                        Uncategorized</li>
                      <li class="list-group-item" style="font-size: 14px" v-for="division in divisionList"
                        :key="division.id" :class="[{ selected2: divisionId == division.id }]">
                        <div class="row" @click="setDivision(division.id)">
                          <div class="col-md-8">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item v-if="accessRights.includes('V')" key=1
                                  @click="showDrawer('viewCategory', 'division', division)"> View - {{ division.name }}
                                </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('W')" key=2
                                  @click="showDrawer('editCategory', 'division', division)"> Edit - {{ division.name }}
                                </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('D')" key=3>
                                  <a-popconfirm title="You are about to delete this record?" okText="Delete"
                                    cancelText="Cancel" @confirm="deleteData(division)">
                                    Delete - {{ division.name }}
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown> &nbsp;
                            {{ division.name }}
                          </div>
                          <div class="col-md-4"><span class="ni ni-bold-right float-right"
                              style="padding-bottom: 5px" /></div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
                <div class="col-md-3 col-sm-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                  <ul class="list-group list-group-flush" style="width: 100%;">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                      <div class="row">
                        <div class="col-md-8">DEPARTMENT</div>
                        <div class="col-md-4 float-right">
                          <base-button v-if="accessRights.includes('A')" class="float-right ml-1" type="primary"
                            size="sm" :disabled="divisionId == null"
                            @click.prevent="showDrawer('addCategory', 'department', null)"><span class="fa fa-plus" />
                          </base-button>
                        </div>
                      </div>
                    </li>
                    <div style="height: 545px; overflow-y: auto;">
                      <li class="list-group-item" style="font-size: 14px" v-for="department in departmentList"
                        :key="department.id" :class="[{ selected2: departmentId == department.id }]">
                        <div class="row" @click="setDepartment(department.id)">
                          <div class="col-md-8">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item v-if="accessRights.includes('V')" key=1
                                  @click="showDrawer('editCaviewCategorytegory', 'department', department)"> View - {{ department.name }}
                                </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('W')" key=2
                                  @click="showDrawer('editCategory', 'department', department)"> Edit -
                                  {{ department.name }} </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('D')" key=3>
                                  <a-popconfirm title="You are about to delete this record?" okText="Delete"
                                    cancelText="Cancel" @confirm="deleteOption(product)">
                                    Delete - {{ department.name }}
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown> &nbsp;
                            {{ department.name }}
                          </div>
                          <div class="col-md-4"><span class="ni ni-bold-right float-right"
                              style="padding-bottom: 5px" /></div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
                <div class="col-md-3 col-sm-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                  <ul class="list-group list-group-flush" style="width: 100%;">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                      <div class="row">
                        <div class="col-md-8">SECTION</div>
                        <div class="col-md-4 float-right">
                          <base-button v-if="accessRights.includes('A')" class="float-right ml-1" type="primary"
                            size="sm" :disabled="departmentId == null"
                            @click.prevent="showDrawer('addCategory', 'section', null)"> <span class="fa fa-plus" />
                          </base-button>
                        </div>
                      </div>
                    </li>
                    <div style="height: 545px; overflow-y: auto;">
                      <li class="list-group-item" style="font-size: 14px" v-for="section in sectionList"
                        :key="section.id" :class="[{ selected2: sectionId == section.id }]">
                        <div class="row" @click="setSection(section.id)">
                          <div class="col-md-8">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item v-if="accessRights.includes('V')" key=1
                                  @click="showDrawer('viewCategory', 'section', section)"> View - {{ section.name }}
                                </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('W')" key=2
                                  @click="showDrawer('editCategory', 'section', section)"> Edit - {{ section.name }}
                                </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('D')" key=3>
                                  <a-popconfirm title="You are about to delete this record?" okText="Delete"
                                    cancelText="Cancel" @confirm="deleteData(section)">
                                    Delete - {{ section.name }}
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown> &nbsp;
                            {{ section.name }}
                          </div>
                          <div class="col-md-4"><span class="ni ni-bold-right float-right"
                              style="padding-bottom: 5px" /></div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
                <div class="col-md-3 col-sm-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                  <ul class="list-group list-group-flush" style="width: 100%;">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                      <div class="row">
                        <div class="col-md-8">CLASS</div>
                        <div class="col-md-4 float-right">
                          <base-button v-if="accessRights.includes('A')" class="float-right ml-1" type="primary"
                            size="sm" :disabled="sectionId == null"
                            @click.prevent="showDrawer('addCategory', 'class', null)"> <span class="fa fa-plus" />
                          </base-button>
                        </div>
                      </div>
                    </li>
                    <div style="height: 545px; overflow-y: auto;">
                      <li class="list-group-item" style="font-size: 14px" v-for="class1 in classList" :key="class1.id"
                        :class="[{ selected2: classId == class1.id }]">
                        <div class="row" @click="setClass(class1.id)">
                          <div class="col-md-12">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item v-if="accessRights.includes('V')" key=1
                                  @click="showDrawer('viewCategory', 'class', class1)"> View - {{ class1.name }}
                                </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('W')" key=2
                                  @click="showDrawer('editCategory', 'class', class1)"> Edit - {{ class1.name }}
                                </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('D')" key=3>
                                  <a-popconfirm title="You are about to delete this record?" okText="Delete"
                                    cancelText="Cancel" @confirm="deleteData(class1)">
                                    Delete - {{ class1.name }}
                                  </a-popconfirm>
                                </a-menu-item>
                                <a-menu-item  key=3
                                  @click="showHistoryDrawer(class1)"> History - {{ class1.name }}
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown> &nbsp;
                            {{ class1.name }}
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </a-spin>
      </div>

      <div v-else-if="currentProfile == 'product_option_groups'" class="card mb-3">
        <a-spin :spinning="spinning">
          <div class="card shadow" style="min-height: 100%">
            <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
              <div class="row align-items-center">
                <div class="col-md-12"> Manage Option Groups </div>
                <div class="col-md-10"><small>Set how option product groups are sorted using nested groups</small></div>
                <div class="col-md-2">
                  <base-dropdown class="nav-link pr-0 float-right" position="right">
                    <div class="media align-items-center" slot="title">
                      <i class="fa fa-ellipsis-v float-right btn-sm"></i>
                    </div>
                    <template>
                      <div class=" dropdown-header noti-title">
                        <h6 class="text-overflow m-0">ACTIONS</h6>
                      </div>
                      <div v-if="accessRights.includes('E')" class="dropdown-item" @click.prevent="downloadCategories">
                        <i class="fa fa-download"></i>
                        <span>Export Option Groups</span>
                      </div>
                    </template>
                  </base-dropdown>
                </div>
                <div class="col-md-12"><br></div>
                <div class="col-md-6 col-sm-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                      <div class="row">
                        <div class="col-md-8">OPTION GROUPS</div>
                        <div v-if="accessRights.includes('A')" class="col-md-4 float-right">
                          <base-button class="float-right ml-1" type="primary" size="sm"
                            @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus" />
                          </base-button>
                        </div>
                      </div>
                    </li>

                    <div style="height: 545px; overflow-y: auto;">
                      <li class="list-group-item" style="font-size: 14px" v-for="optionGroup in optionGroupList"
                        :key="optionGroup.id" :class="[{ selected2: optionGroupId == optionGroup.id }]">
                        <div class="row" @click="setOptionGroup(optionGroup.id)">
                          <div class="col-md-8">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item v-if="accessRights.includes('W')" key=1
                                  @click="showDrawer('editOptionGroup', 'optionGroup', optionGroup)"> Edit -
                                  {{ optionGroup.name }} </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('D')" key=2>
                                  <a-popconfirm title="You are about to delete this record?" okText="Delete"
                                    cancelText="Cancel" @confirm="deleteData(division)">
                                    Delete - {{ optionGroup.name }}
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown> &nbsp;
                            {{ optionGroup.name }}
                          </div>
                          <div class="col-md-4"><span class="ni ni-bold-right float-right"
                              style="padding-bottom: 5px" /></div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
                <div class="col-md-6 col-sm-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                  <ul class="list-group list-group-flush" style="width: 100%;">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                      <div class="row">
                        <div class="col-md-8">OPTION PRODUCTS</div>
                        <div class="col-md-4 float-right">
                          <base-button v-if="accessRights.includes('A')" class="float-right ml-1" type="primary"
                            size="sm" :disabled="optionGroupId == null"
                            @click.prevent="showDrawer('addOption', 'product', null); clearProduct();"><span
                              class="fa fa-plus" /> </base-button>
                        </div>
                      </div>
                    </li>
                    <div style="height: 545px; overflow-y: auto;">
                      <li class="list-group-item" style="font-size: 14px" v-for="product in productList"
                        :key="product.id" :class="[{ selected2: productId == product.id }]">
                        <div class="row">
                          <div class="col-md-8">
                            <a-dropdown>
                              <a class="ant-dropdown-link" href="#">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item v-if="accessRights.includes('W')" key=1
                                  @click="showDrawer('editOption', 'product', product)"> Edit - {{ product.name }}
                                </a-menu-item>
                                <a-menu-item v-if="accessRights.includes('D')" key=2>
                                  <a-popconfirm title="You are about to delete this record?" okText="Delete"
                                    cancelText="Cancel" @confirm="deleteData(department)">
                                    Delete - {{ product.name }}
                                    <a-badge class="float-right" color="lime" text="0.00" />
                                    <!-- <a-badge class="float-right" count="Price: 0.00 " :number-style="{ backgroundColor: '#52c41a' }" /> -->
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown> &nbsp;
                            {{ product.name }}
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </a-spin>
      </div>

      <div v-else-if="currentProfile == 'product_combo_groups'" class="card mb-3">
        <a-spin :spinning="spinning">
          <div class="card shadow" style="min-height: 100%">
            <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
              <div class="row align-items-center">
                <div class="col-md-12"> Manage Combo Groups </div>
                <div class="col-md-10"><small>Set how combo product groups are sorted using nested groups</small></div>
                <div class="col-md-2">
                  <base-dropdown class="nav-link pr-0 float-right" position="right" slot="tabBarExtraContent">
                      <div class="media align-items-center" slot="title">
                        <i class="fa fa-ellipsis-v float-right btn-sm"></i>
                      </div>
                      <template>
                        <div class=" dropdown-header noti-title">
                          <h6 class="text-overflow m-0">ACTIONS</h6>
                        </div>
                        <div v-if="accessRights.includes('E')" class="dropdown-item"
                          @click.prevent="downloadCategories">
                          <i class="fa fa-download"></i>
                          <span>Export Combo Groups</span>
                        </div>
                      </template>
                    </base-dropdown>
                </div>
                <!-- <div class="col-md-12"><br></div> -->
                <div class="mx-3" style="width: 100%">
                      <div class="row">
                        <!-- <div class="col-md-2 col-sm-2">
                          <div class="card-container">
                            filters go here
                          </div>
                        </div> -->
                        <div class="col-md-6 col-sm-6"
                          style="padding-right: 0px; border-right: 1px #E9ECEF solid; height: 640px;">
                          <ul class="list-group list-group-flush">
                            <li class="list-group-item"
                              style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                              <div class="row">
                                <div class="col-md-8">COMBO GROUPS</div>
                                <div v-if="accessRights.includes('A')" class="col-md-4 float-right">
                                  <base-button class="float-right ml-1" type="primary" size="sm"
                                    @click.prevent="showDrawer('addComboGroup', 'comboGroup', null)"><span
                                      class="fa fa-plus" />
                                  </base-button>
                                </div>
                              </div>
                            </li>
                            <div style="height: 545px; overflow-y: auto;">
                              <li class="list-group-item" style="font-size: 14px" v-for="comboGroup in comboGroupList"
                                :key="comboGroup.id" :class="[{ selected2: comboGroupId == comboGroup.id }]"
                                @click="setComboGroup(comboGroup.id)">
                                <div class="row">
                                  <div class="col-md-8">
                                    <a-dropdown>
                                      <a class="ant-dropdown-link" href="#">
                                        <span class="fa fa-ellipsis-v"></span>
                                      </a>
                                      <a-menu slot="overlay">
                                        <a-menu-item v-if="accessRights.includes('W')" key=1
                                          @click="showDrawer('editComboGroup', 'comboGroup', comboGroup)"> Edit -
                                          {{ comboGroup.name }} </a-menu-item>
                                        <a-menu-item v-if="accessRights.includes('D')" key=2>
                                          <a-popconfirm title="You are about to delete this record?" okText="Delete"
                                            cancelText="Cancel" @confirm="deleteComboGroup(comboGroup)">
                                            Delete - {{ comboGroup.name }}
                                          </a-popconfirm>
                                        </a-menu-item>
                                      </a-menu>
                                    </a-dropdown> &nbsp;
                                    {{ comboGroup.name }}
                                  </div>
                                  <div class="col-md-4"
                                    style="display: flex; justify-content: right; place-items: center;">
                                    <span class="ni ni-bold-right float-right" />
                                  </div>
                                </div>
                              </li>
                            </div>
                          </ul>
                          <a-pagination class="mx-3 my-2 float-right" :current="comboPage" :pageSize="comboPageSize"
                            :total="comboTotal" size="small" @change="changeComboPage" />
                          <!-- <vuetable-pagination></vuetable-pagination> -->
                        </div>
                        <div class="col-md-6 col-sm-6"
                          style="padding-left: 0px; border-right: 1px #E9ECEF solid; height: 640px;">
                          <ul class="list-group list-group-flush" style="width: 100%;">
                            <li class="list-group-item"
                              style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                              <div class="row">
                                <div class="col-md-8">COMBO VALUES</div>
                                <div class="col-md-4 float-right">
                                  <base-button v-if="accessRights.includes('A')" class="float-right ml-1" type="primary"
                                    size="sm" :disabled="comboGroupId == null"
                                    @click.prevent="showDrawer('addCombo', 'comboproduct', null); clearProductCombo();">
                                    <span class="fa fa-plus" />
                                  </base-button>
                                </div>
                              </div>
                            </li>
                            <div style="height: 545px; overflow-y: auto;">
                              <li class="list-group-item" style="font-size: 14px"
                                v-for="comboproduct in comboproductList" :key="comboproduct.id"
                                :class="[{ selected2: comboproductId == comboproduct.id }]">
                                <div class="row">
                                  <div class="col-md-12">
                                    <a-dropdown>
                                      <a class="ant-dropdown-link" href="#">
                                        <span class="fa fa-ellipsis-v"></span>
                                      </a>
                                      <a-menu slot="overlay">
                                        <a-menu-item v-if="accessRights.includes('W')" key=1
                                          @click="showDrawer('editCombo', 'comboproduct', comboproduct)"> Edit -
                                          {{ comboproduct.name }} </a-menu-item>
                                        <a-menu-item v-if="accessRights.includes('D')" key=2>
                                          <a-popconfirm title="You are about to delete this record?" okText="Delete"
                                            cancelText="Cancel" @confirm="deleteCombo(comboproduct)">
                                            Delete - {{ comboproduct.name }}
                                          </a-popconfirm>
                                        </a-menu-item>
                                      </a-menu>
                                    </a-dropdown> &nbsp;
                                    {{ comboproduct.name }}
                                    <a-badge class="float-right" color="lime" :text="comboproduct.price" />
                                  </div>
                                  <!-- <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div> -->
                                </div>
                              </li>
                            </div>
                          </ul>
                        </div>
                      </div>

                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </div>

      <div v-else class="row">
        <div class="col">
          <div class="card mb-3">

            <div v-if="(currentProfile == 'size_groups')" class="row no-gutters">

              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">

                <div class="card-body">
                  <filter-bar @changeFilter="changeFilter"></filter-bar>
                </div>
              </div>

              <div class="col-md-9" style="overflow: scroll;">
                <div class="row no-gutters" style="min-height: 100%">
                  <div class="col-md-12" style="border-right: 1px solid #e0e0e0;">
                    <profiles-table :status="filterStatus" :key="formKey" :accessRights="accessRights"></profiles-table>
                  </div>

                  <div class="col-md-12">
                    <hr />
                    <small class="ml-2"> <span class="fa fa-info-circle" /> Please select a size group. </small>
                    <size-group :key="formKey2" :accessRights="accessRights"></size-group>
                  </div>
                </div>
              </div>
            </div>

            <!-- Brand | brand and sub-brand | Sub Brand -->
            <div v-else-if="(currentProfile == 'brands')" class="row no-gutters">

              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">

                <div class="card-body">
                  <filter-bar @changeFilter="changeFilter"></filter-bar>
                </div>
              </div>

              <div class="col-md-9" style="overflow: scroll;">
                <div class="row no-gutters" style="min-height: 100%">
                  <div class="col-md-12" style="border-right: 1px solid #e0e0e0;">
                    <profiles-table :status="filterStatus" :key="formKey" :accessRights="accessRights"></profiles-table>
                  </div>

                  <!-- SubBrand | sub brand | sub-brand -->
                  <div class="col-md-12">
                    <hr />
                    <small class="ml-2"> <span class="f0a fa-info-circle" /> Please select a sub brand. </small>
                    <sub-brand :key="formKey2" :accessRights="accessRights"></sub-brand>
                  </div>
                  <!-- end SubBrand | sub brand | sub-brand -->
                </div>
              </div>
            </div>
            <!-- end Brand | brand and sub-brand | Sub Brand -->

                      <!-- Product Instruction -->
                      <div v-else-if="(currentProfile == 'product_instructions')" class="row no-gutters">
                          <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                            <div class="card-body">
                                <filter-bar @changeFilter="changeFilter"></filter-bar>
                            </div>
                          </div>

                          <div class="col-md-9">
                            <div class="card-body">
                                <product-instruction-table :status="filterStatus" :key="formKey" :accessRights="accessRights"></product-instruction-table>
                            </div>
                          </div>
                      </div>


            <div v-else class="row no-gutters">
              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                  <filter-bar @changeFilter="changeFilter"></filter-bar>
                </div>
              </div>

              <div class="col-md-9">
                <div class="card-body">
                  <profiles-table :status="filterStatus" :key="formKey" :accessRights="accessRights"></profiles-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import ProfilesTable from '../Tables/ProductProfilesTable.vue'
  import ProductInstructionTable from '../Tables/ProductInstructionsTable.vue'
import SizeGroup from '../Product Profiles V2/SizeGroup.vue'
import SubBrand from '../Product Profiles V2/SubBrand.vue' // sub brand component
import FilterBar from './../FilterBar'
import ValidateField from '../../components/validateFormUtils.js'
import Autocomplete from "vuejs-auto-complete"
import DynamicForm from '../DynamicForm.vue'
import { mapState, mapActions } from 'vuex'

var ObjGen = require('../../../node_modules/objgen/objgen.js').ObjGen;

const histories_column = [
  { title: "Action", dataIndex: "action", key: "action" },
  { title: "Field Name", dataIndex: "field_name", key: "field_name" },
  { title: "From", dataIndex: "old_value", key: "old_value", width: '100px' },
  { title: "To", dataIndex: "new_value", key: "new_value", width: '100px', },
  { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
  // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
  { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
];

export default {
  data: function () {
    return {
      viewMode: false,
      optionGroupList: [],
      optionGroupId: null,
      productList: [],
      productId: null,
      prdoptgrp: {},
      prdopt: {
        code: null,
        name: null,
        product_option_group_id: null,
        sequence_no: null
      },
      prodoptgrp: [],

      comboGroupList: [],
      comboGroupId: null,
      comboproductList: [],
      comboproductId: null,
      prdcmbgrp: {
        id: null,
        name: null,
        sequence_no: null,
        status: null,
        combo_value_link: null,
        combo_value_link_arr: [],
        product_id: null,
        reference_code: null,
        option_type: null,
        card_type_id: null,
        is_required: false,
        is_freebie: false,
      },
      prdcmb: {
        product_code: null,
        name: null,
        reference_code: null,
        description: null,
        price: null,
        product_combo_group_id: null,
        sequence_no: null,
        min_qty: null,
        max_qty: null,
        status: null,
      },
      comboPage: 1,
      comboPageSize: 10,
      comboTotal: 0,
      comboValueLinks: [],
      comboValueCascade: [], 
      productSearchList: [],
      supercardTypes: [],
      fetchingCardTypes: false,

      searchFilter: "name",
      placeholder: "Search product by Name",
      authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
      categoryName: '',
      categoryCode: '',
      categoryRefCode: '',
      categoryRemark: '',
      categorySequenceNo: null,
      spinning: false,
      filterStatus: "",
      activeModules: [],
      formKey: 0,
      divisionList: [],
      divisionId: null,
      departmentList: [],
      departmentId: null,
      sectionList: [],
      sectionId: null,
      classList: [],
      classId: null,
      formId: null,
      visible: false,
      type: null,
      jsonField: null,
      convertedJson: null,
      formSettings: {},
      componentKey: 0,
      accessRights: [],
      formKey2: 0,
      errors: [],

      historyVisible: false,
      historyColumns: histories_column,
      historyData: null,
      loading: false,
      pagination: false,
    }
  },
  mounted: async function () {
    // let component_x = this
    this.spinning = true
    var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=MCS-001', null, null)
    this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)
    if (this.activeModules.length > 0) {
      var profile = _.snakeCase(this.activeModules[0].name)
      this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
    } else {
      this.setCurrentProfile(null, null);
      this.formKey++
    }
    this.spinning = false

  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'parentId', 'serverType']),
  },
  components: {
    ProfilesTable, ProductInstructionTable, FilterBar, SizeGroup, DynamicForm, SubBrand, Autocomplete
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters', 'updateParentId']),
    async fetchSupercardTypes (searchValue = '') {
      this.fetchingCardTypes = true
      let response = await HTTPRequest.getRequest(this.endPoint + `supercard_types?name=${encodeURIComponent(searchValue)}&per_page=50`, null, null)
      this.fetchingCardTypes = false

      if (response && response.data != undefined) {
        this.supercardTypes = response.data
      } else if (response && response.error == undefined && Array.isArray(response)) {
        this.supercardTypes = response
      }
    },
    updateSettings (formSettings, settingsGrouping) {
      this.formSettings = formSettings
    },
    async setCurrentProfile (profile, id) {
      this.spinning = true
      this.profileId = id
      var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
      if (_.isEmpty(accessRightsRequest.access_rights) == false) {
        this.accessRights = accessRightsRequest.access_rights[id]
      } else {
        this.accessRights = []
      }
      this.updateCurrentProfile(profile)
      if (profile == "size_groups")
        this.formKey2++;
      this.formKey++

      if (profile == "categories") {
        // alert("Do something.")
        var division = await HTTPRequest.getRequest(this.endPoint + "/categories?level=1", null)
        this.divisionList = division
        this.divisionId = null
        this.departmentList = []
        this.departmentId = null
        this.sectionList = []
        this.sectionId = null
        this.classList = []
        this.classId = null
      } else if (profile == "product_option_groups") {
        var optionGroups = await HTTPRequest.getRequest(this.endPoint + "/product_option_groups", null)
        this.optionGroupList = optionGroups.data
        this.optionGroupId = null
        this.prodoptgrp = optionGroups.data
      } else if (profile == "product_combo_groups") {
        var comboGroups = await HTTPRequest.getRequest(this.endPoint + `/product_combo_groups?per_page=${this.comboPageSize}`, null)
        this.comboPage = comboGroups.current_page
        this.comboTotal = comboGroups.total
        this.comboGroupList = comboGroups.data
        this.comboGroupId = null
        this.prodcmbgrp = comboGroups.data
      } else {
        this.setParentId(0);
      }
      this.spinning = false

    },
    async setOptionGroup (optionGroupId) {
      this.spinning = true
      this.optionGroupId = optionGroupId
      var products = await HTTPRequest.getRequest(this.endPoint + "/product_options?product_option_group_id=" + this.optionGroupId, null)
      this.productList = products.data
      this.productId = null

      this.spinning = false
    },
    async setComboGroup (comboGroupId) {
      this.spinning = true
      this.comboGroupId = comboGroupId
      var products = await HTTPRequest.getRequest(this.endPoint + "/product_combo_values?product_combo_group_id=" + this.comboGroupId, null)
      this.comboproductList = products.data
      this.comboproductId = null

      this.spinning = false
    },
    async setDivision (divisionId) {
      this.spinning = true
      this.divisionId = divisionId
      var departments = await HTTPRequest.getRequest(this.endPoint + "/categories?parent_category_id=" + this.divisionId, null)
      this.departmentList = departments
      this.departmentId = null
      this.sectionList = []
      this.sectionId = null
      this.classList = []
      this.classId = null
      this.spinning = false
    },
    async setDepartment (departmentId) {
      this.spinning = true
      this.departmentId = departmentId
      var sections = await HTTPRequest.getRequest(this.endPoint + "/categories?parent_category_id=" + this.departmentId, null)
      this.sectionList = sections
      this.sectionId = null
      this.classList = []
      this.classId = null
      this.spinning = false
    },
    async setSection (sectionId) {
      this.spinning = true
      this.sectionId = sectionId
      var classes = await HTTPRequest.getRequest(this.endPoint + "/categories?per_page=500&parent_category_id=" + this.sectionId, null)
      this.classList = classes
      this.classId = null
      this.spinning = false
    },
    async setClass (classId) {
      this.classId = classId
      //   var classes = await HTTPRequest.getRequest(this.endPoint + "/categories?parent_category_id=" + this.sectionId, null)
      //   this.classList = classes.data
    },
    changeSearchFilter (searchFilter) {
      this.searchFilter = searchFilter
      this.placeholder = "Search product by " + searchFilter
    },
    productEndpoint (input) {
      return this.endPoint + '/products?' + this.searchFilter + '=' + input;
    },
    formattedDisplay (result) {
      return result.name;
    },
    getProduct (group) {
      this.prdopt.code = group.selectedObject.barcode;
      this.prdopt.name = group.selectedObject.name
    },
    clearProduct () {
      this.prdopt.code = null
      this.prdopt.name = null
    },
    getProductCombo (group) {
      this.prdcmb.product_code = group.selectedObject.barcode;
      this.prdcmb.name = group.selectedObject.name
      this.prdcmb.price = group.selectedObject.retail_price
    },
    clearProductCombo () {
      this.prdcmb.product_code = null
      this.prdcmb.name = null
      this.prdcmb.price = null
    },
    addOptionGroup: async function () {
      if (!this.validateOptionGroupForm()) {
        this.prdoptgrp.name = this.prdoptgrp.name.trim()
        if (this.prdoptgrp.code != undefined)
          this.prdoptgrp.code = this.prdoptgrp.code.trim()
        this.prdoptgrp.status = 'A'
        var groupPayload = { product_option_groups: this.prdoptgrp }

        var post_request = await HTTPRequest.postRequest(this.endPoint + 'product_option_groups', null, groupPayload)
        if (post_request == undefined) {
          this.$emit('refreshPage', event)
        } else {
          if (post_request["error"] == undefined) {
            this.visible = false
            this.setCurrentProfile(this.currentProfile, this.currentProfileId)
          } else {
            this.errors = post_request["error"].split(",")
          }
        }
      }
    },
    addOption: async function () {
      if (!this.validateOptionForm()) {
        this.prdopt.name = this.prdopt.name.trim()
        if (this.prdopt.code != undefined)
          this.prdopt.code = this.prdopt.code.trim()
        this.prdopt.status = 'A'
        var optionPayload = { product_options: this.prdopt }

        var post_request = await HTTPRequest.postRequest(this.endPoint + 'product_options', null, optionPayload)
        if (post_request == undefined) {
          this.$emit('refreshPage', event)
        } else {
          if (post_request["error"] == undefined) {
            this.visible = false
            this.setOptionGroup(this.optionGroupId)
          } else {
            this.errors = post_request["error"].split(",")
          }
        }
      }
    },
    addCombo: async function () {
      if (!this.validateComboForm()) {
        this.prdcmb.name = this.prdcmb.name.trim()
        if (this.prdcmb.product_code != undefined)
          this.prdcmb.product_code = this.prdcmb.product_code.trim()
        this.prdcmb.status = 'A'
        var comboPayload = { product_combos: this.prdcmb }

        var post_request = await HTTPRequest.postRequest(this.endPoint + 'product_combos', null, comboPayload)
        if (post_request == undefined) {
          this.$emit('refreshPage', event)
        } else {
          if (post_request["error"] == undefined) {
            this.visible = false
            this.setComboGroup(this.comboGroupId)
          } else {
            this.errors = post_request["error"].split(",")
          }
        }
      }
    },
    addComboGroup: async function () {
      if (!this.validateComboGroupForm()) {
        this.prdcmbgrp.name = this.prdcmbgrp.name.trim()
        // if (this.prdcmbgrp.code != undefined)
        //   this.prdcmbgrp.code = this.prdcmbgrp.code.trim()
        // this.prdcmbgrp.status = 'A'
        var groupPayload = { product_combo_groups: this.prdcmbgrp }

        var post_request = await HTTPRequest.postRequest(this.endPoint + 'product_combo_groups', null, groupPayload)
        if (post_request == undefined) {
          this.$emit('refreshPage', event)
        } else {
          if (post_request["error"] == undefined) {
            this.visible = false
            this.setCurrentProfile(this.currentProfile, this.currentProfileId)
          } else {
            this.errors = post_request["error"].split(",")
          }
        }
      }
    },
    updateOptionGroup: async function () {
      if (!this.validateOptionGroupForm()) {

        this.prdoptgrp.name = this.prdoptgrp.name.trim()
        if (this.prdoptgrp.code != undefined)
          this.prdoptgrp.code = this.prdoptgrp.code.trim()
        this.prdoptgrp.status = 'A'
        var groupPayload = { product_option_groups: this.prdoptgrp }

        var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_option_groups/' + this.prdoptgrp.id, null, groupPayload)

        if (put_request == undefined) {
          this.$emit('refreshPage', event)
        } else {
          if (put_request["error"] == undefined) {
            this.visible = false
            this.setCurrentProfile(this.currentProfile, this.currentProfileId)
          } else {
            this.errors = put_request["error"].split(",")
          }
        }
      }
    },
    updateOption: async function () {
      if (!this.validateOptionForm()) {

        this.prdopt.name = this.prdopt.name.trim()
        if (this.prdopt.code != undefined)
          this.prdopt.code = this.prdopt.code.trim()
        this.prdopt.status = 'A'
        var optionPayload = { product_options: this.prdopt }

        var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_options/' + this.prdopt.id, null, optionPayload)

        if (put_request == undefined) {
          this.$emit('refreshPage', event)
        } else {
          if (put_request["error"] == undefined) {
            this.visible = false
            this.setOptionGroup(this.optionGroupId)
          } else {
            this.errors = put_request["error"].split(",")
          }
        }
      }
    },
    updateComboGroup: async function () {
      if (!this.validateComboGroupForm()) {

        this.prdcmbgrp.name = this.prdcmbgrp.name.trim()
        this.prdcmbgrp.combo_value_link = this.prdcmbgrp.combo_value_link_arr[1]
        var groupPayload = { product_combo_groups: this.prdcmbgrp }

        var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_combo_groups/' + this.prdcmbgrp.id, null, groupPayload)

        if (put_request == undefined) {
          this.$emit('refreshPage', event)
        } else {
          if (put_request["error"] == undefined) {
            this.visible = false
            this.$notification['success']({
              message: 'Product Combo Group successfully updated.',
            });
            
            this.changeComboPage(this.comboPage, this.comboPageSize)
            // console.log(`currentProfile: ${this.currentProfile}`)
            // console.log(`currentProfileId: ${this.currentProfileId}`)
            // this.setCurrentProfile(this.currentProfile, this.currentProfileId)
          } else {
            this.errors = put_request["error"].split(",")
          }
        }
      }
    },
    updateCombo: async function () {
      if (!this.validateComboForm()) {

        this.prdcmb.name = this.prdcmb.name.trim()
        if (this.prdcmb.product_code != undefined)
          this.prdcmb.product_code = this.prdcmb.product_code.trim()
        this.prdcmb.status = 'A'
        var groupPayload = { product_combos: this.prdcmb }

        var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_combos/' + this.prdcmb.id, null, groupPayload)

        if (put_request == undefined) {
          this.$emit('refreshPage', event)
        } else {
          if (put_request["error"] == undefined) {
            this.visible = false
            this.setComboGroup(this.comboGroupId)
          } else {
            this.errors = put_request["error"].split(",")
          }
        }
      }
    },
    async deleteOptionGroup (optionGroup) {
      this.selectedKey = optionGroup.id

      var groupPayload = { product_option_groups: { status: "D" } }
      var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_option_groups/' + this.selectedKey, null, groupPayload)

      if (put_request == undefined) {
        this.$emit('refreshPage', event)
      } else {
        if (put_request["error"] == undefined) {
          this.visible = false
          this.setCurrentProfile(this.currentProfile, this.currentProfileId)
        } else {
          this.errors = put_request["error"].split(",")
        }
      }
    },
    async deleteOption (option) {
      this.selectedKey = option.id

      var groupPayload = { product_options: { status: "D" } }
      var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_options/' + this.selectedKey, null, groupPayload)

      if (put_request == undefined) {
        this.$emit('refreshPage', event)
      } else {
        if (put_request["error"] == undefined) {
          this.visible = false
          this.setOptionGroup(this.optionGroupId)
        } else {
          this.errors = put_request["error"].split(",")
        }
      }
    },
    async deleteComboGroup (combo) {
      this.selectedKey = combo.id

      var groupPayload = { product_combo_groups: { status: "D" } }
      var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_combo_groups/' + this.selectedKey, null, groupPayload)

      if (put_request == undefined) {
        this.$emit('refreshPage', event)
      } else {
        if (put_request["error"] == undefined) {
          this.visible = false
          this.setCurrentProfile(this.currentProfile, this.currentProfileId)
        } else {
          this.errors = put_request["error"].split(",")
        }
      }
    },
    async deleteCombo (combo) {
      this.selectedKey = combo.id

      var groupPayload = { product_combos: { status: "D" } }
      var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_combos/' + this.selectedKey, null, groupPayload)

      if (put_request == undefined) {
        this.$emit('refreshPage', event)
      } else {
        if (put_request["error"] == undefined) {
          this.visible = false
          this.setComboGroup(this.comboGroupId)
        } else {
          this.errors = put_request["error"].split(",")
        }
      }
    },
    validateOptionGroupForm () {
      this.errors = [];
      this.errors.push(ValidateField.required('Code', this.prdoptgrp.code));
      this.errors.push(ValidateField.charMinAndMax('Code', this.prdoptgrp.code, 0, 30));
      this.errors.push(ValidateField.required('Name', this.prdoptgrp.name));
      this.errors.push(ValidateField.charMinAndMax('Name', this.prdoptgrp.name, 0, 200));
      this.errors.push(ValidateField.required('Sequence Number', this.prdoptgrp.sequence_no));
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
      return this.errors.length;
    },
    validateOptionForm () {
      this.errors = [];
      this.errors.push(ValidateField.charMinAndMax('Code', this.prdopt.code, 0, 30));
      this.errors.push(ValidateField.required('Name', this.prdopt.name));
      this.errors.push(ValidateField.charMinAndMax('Name', this.prdopt.name, 0, 200));
      this.errors.push(ValidateField.required('Product Option Group', this.prdopt.product_option_group_id));
      this.errors.push(ValidateField.required('Sequence Number', this.prdopt.sequence_no));
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
      return this.errors.length;
    },
    validateComboGroupForm () {
      this.errors = [];
      // this.errors.push(ValidateField.required('Code', this.prdcmbgrp.code));
      // this.errors.push(ValidateField.charMinAndMax('Code', this.prdcmbgrp.code, 0, 30));
      this.errors.push(ValidateField.required('Name', this.prdcmbgrp.name));
      this.errors.push(ValidateField.charMinAndMax('Name', this.prdcmbgrp.name, 0, 200));
      this.errors.push(ValidateField.required('Sequence Number', this.prdcmbgrp.sequence_no));
      // this.errors.push(ValidateField.required('Minimum Quantity', this.prdcmbgrp.min_qty));
      // this.errors.push(ValidateField.required('Maximum Quantity', this.prdcmbgrp.max_qty));
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
      return this.errors.length;
    },
    validateComboForm () {
      this.errors = [];
      this.errors.push(ValidateField.required('Product Barcode', this.prdcmb.product_code));
      this.errors.push(ValidateField.charMinAndMax('Product Barcode', this.prdcmb.product_code, 0, 30));
      this.errors.push(ValidateField.required('Name', this.prdcmb.name));
      this.errors.push(ValidateField.charMinAndMax('Name', this.prdcmb.name, 0, 200));
      this.errors.push(ValidateField.required('Sequence Number', this.prdcmb.sequence_no));
      this.errors.push(ValidateField.required('Minimum Quantity', this.prdcmb.min_qty));
      this.errors.push(ValidateField.required('Maximum Quantity', this.prdcmb.max_qty));
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
      return this.errors.length;
    },
    async showDrawer (type, mode, category) {
      this.errors = [];
      this.formId = type
      this.visible = true
      var jsonField;
      if (type == 'viewCategory'){
        this.viewMode = true;
        switch (mode) {
          case "division":
            this.categoryLevel = 1
            break;
          case "department":
            this.categoryLevel = 2
            break;
          case "section":
            this.categoryLevel = 3
            break;
          case "class":
            this.categoryLevel = 4
            break;
        }
        this.selectedKey = category.id
        this.categoryName = category.name
        this.categoryCode = category.code
        this.categoryRefCode = category.refcode
        this.categoryRemark = category.remark
        this.categorySequenceNo = category.sequence_no

        if (this.categoryLevel == 4) {
          jsonField = await HTTPRequest.getRequest(this.endPoint + 'dynamic_forms/Product Category?field_name=profile_name', null, null)
          this.convertedJson = ObjGen.xJson(jsonField.template, { numSpaces: 2 })

          var formSettings = await HTTPRequest.getRequest(this.endPoint + 'categories/' + category.id + "/get_settings", null, null)
          this.formSettings = JSON.parse(formSettings["settings"])
          this.componentKey++

        }
      }
      if (type == 'addCategory') {
        this.clearData()
        switch (mode) {
          case "division":
            // this.selectedKey = -1
            this.selectedKey = 0
            this.categoryLevel = 1
            break;
          case "department":
            this.selectedKey = this.divisionId
            this.categoryLevel = 2
            break;
          case "section":
            this.selectedKey = this.departmentId
            this.categoryLevel = 3
            break;
          case "class":
            this.selectedKey = this.sectionId
            this.categoryLevel = 4
            break;
        }
        this.categoryName = "New Level " + this.categoryLevel.toString()
        if (this.categoryLevel == 4) {
          jsonField = await HTTPRequest.getRequest(this.endPoint + 'dynamic_forms/Product Category?field_name=profile_name', null, null)
          this.convertedJson = ObjGen.xJson(jsonField.template, { numSpaces: 2 })
        }
      }

      if (type == 'editCategory') {
        switch (mode) {
          case "division":
            this.categoryLevel = 1
            break;
          case "department":
            this.categoryLevel = 2
            break;
          case "section":
            this.categoryLevel = 3
            break;
          case "class":
            this.categoryLevel = 4
            break;
        }
        this.selectedKey = category.id
        this.categoryName = category.name
        this.categoryCode = category.code
        this.categoryRefCode = category.refcode
        this.categoryRemark = category.remark
        this.categorySequenceNo = category.sequence_no

        if (this.categoryLevel == 4) {
          jsonField = await HTTPRequest.getRequest(this.endPoint + 'dynamic_forms/Product Category?field_name=profile_name', null, null)
          this.convertedJson = ObjGen.xJson(jsonField.template, { numSpaces: 2 })

          var formSettings = await HTTPRequest.getRequest(this.endPoint + 'categories/' + category.id + "/get_settings", null, null)
          this.formSettings = JSON.parse(formSettings["settings"])
          this.componentKey++

        }
      }

      if (type == 'editOptionGroup') {
        this.selectedKey = category.id
        this.prdoptgrp.id = category.id
        this.prdoptgrp.name = category.name
        this.prdoptgrp.code = category.code
        this.prdoptgrp.sequence_no = category.sequence_no
      }

      if (type == 'addOptionGroup') {
        this.selectedKey = ''
        this.prdoptgrp.id = ''
        this.prdoptgrp.name = ''
        this.prdoptgrp.code = ''
        this.prdoptgrp.sequence_no = ''
      }

      if (type == 'editOption') {
        this.selectedKey = category.id
        this.prdopt.id = category.id
        this.prdopt.name = category.name
        this.prdopt.code = category.code
        this.prdopt.product_option_group_id = category.product_option_group_id
        this.prdopt.sequence_no = category.sequence_no
      }

      if (type == 'addOption') {
        this.selectedKey = ''
        this.prdopt.id = ''
        this.prdopt.name = ''
        this.prdopt.code = ''
        this.prdopt.product_option_group_id = this.optionGroupId
        this.prdopt.sequence_no = ''
      }

      if (type == 'editComboGroup') {
        if (!this.supercardTypes.length) {
          await this.fetchSupercardTypes()
        }
        // Reset Combo Value Link Cascader
        this.comboValueCascade = []

        this.selectedKey = category.id
        this.prdcmbgrp.id = category.id
        this.prdcmbgrp.name = category.name
        this.prdcmbgrp.sequence_no = category.sequence_no
        this.prdcmbgrp.status = category.status

        this.prdcmbgrp.product_id = category.product_id

        let productCombos = await HTTPRequest.getRequest(`${this.endPoint}product_combo_groups?product_id=${this.prdcmbgrp.product_id}`, null, null)
        productCombos.data.forEach(async (productCombo) => {
          if (productCombo.id != category.id) {
            let comboValues = await HTTPRequest.getRequest(`${this.endPoint}product_combo_values?product_combo_group_id=${productCombo.id}`, null, null)

            let children = comboValues.data.map(comboValue => {
              return {
                value: comboValue.id,
                label: comboValue.name
              }
            })

            let option = {
              value: productCombo.id,
              label: productCombo.name,
              isLeaf: false,
              children: children
            }

            this.comboValueCascade.push(option)
          }
        })

        if (category.combo_value_link) {
          let comboValueLink = await HTTPRequest.getRequest(`${this.endPoint}product_combo_values/${category.combo_value_link}`, null, null)
          this.prdcmbgrp.combo_value_link_arr = [comboValueLink.product_combo_group_id, category.combo_value_link]
        } else {
          this.prdcmbgrp.combo_value_link_arr = []
        }        

        this.productSearchList = []
        let result = await HTTPRequest.getRequest(this.endPoint + `products/${category.product_id}`, null, null)
        this.productSearchList.push(result)
        // console.log(this.productSearchList)

        this.prdcmbgrp.reference_code = category.reference_code
        this.prdcmbgrp.option_type = category.option_type
        this.prdcmbgrp.card_type_id = category.card_type_id || (category.meta_data && category.meta_data.card_type_id) || null
        this.prdcmbgrp.is_required = !!(category.is_required)
        this.prdcmbgrp.is_freebie = !!(category.is_freebie)
      }

      if (type == 'addComboGroup') {
        if (!this.supercardTypes.length) {
          await this.fetchSupercardTypes()
        }
        // this.selectedKey = ''
        // this.prdcmbgrp.id = ''
        // this.prdcmbgrp.name = ''
        // this.prdcmbgrp.code = ''
        // this.prdcmbgrp.sequence_no = ''
        // this.prdcmbgrp.min_qty = ''
        // this.prdcmbgrp.max_qty = ''

        this.selectedKey = ''
        this.prdcmbgrp.id = null
        this.prdcmbgrp.name = ''
        // this.prdcmbgrp.code = category.code
        this.prdcmbgrp.sequence_no = null
        this.prdcmbgrp.status = 'A'
        this.prdcmbgrp.combo_value_link = null
        this.prdcmbgrp.product_id = null
        this.prdcmbgrp.reference_code = ''
        this.prdcmbgrp.option_type = null
        this.prdcmbgrp.card_type_id = null
        this.prdcmbgrp.is_required = false
        this.prdcmbgrp.is_freebie = false
        // this.prdcmbgrp.min_qty = category.min_qty
        // this.prdcmbgrp.max_qty = category.max_qty

      }

      if (type == 'editCombo') {
        this.selectedKey = category.id
        this.prdcmb.id = category.id
        this.prdcmb.name = category.name
        this.prdcmb.description = category.description
        this.prdcmb.product_code = category.product_code
        this.prdcmb.product_combo_group_id = category.product_combo_group_id
        this.prdcmb.sequence_no = category.sequence_no
        this.prdcmb.min_qty = category.min_qty
        this.prdcmb.max_qty = category.max_qty
        this.prdcmb.price = category.price
        this.prdcmb.status = category.status
      }

      if (type == 'addCombo') {
        this.selectedKey = ''
        this.prdcmb.id = ''
        this.prdcmb.name = ''
        this.prdcmb.description = ''
        this.prdcmb.product_code = ''
        this.prdcmb.product_combo_group_id = this.comboGroupId
        this.prdcmb.sequence_no = ''
        this.prdcmb.min_qty = ''
        this.prdcmb.max_qty = ''
        this.prdcmb.price = ''
        this.prdcmb.status = 'A'
      }

      if (this.serverType == 'branch') {
        var form = document.getElementById("form-proper")
        var elements = form.elements;
        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].readOnly = true;
        }
      }
    },
    // DRAWER FUNCTIONS
    onClose () {
      this.visible = false
      this.historyVisible = false
      this.componentKey++
      this.formSettings = {}
    },
    async createData () {
      var categoryPayload = { category: { name: this.categoryName.trim(), code: this.categoryCode.trim(), refcode: this.categoryRefCode ? this.categoryRefCode.trim() : this.categoryRefCode, status: 'A', parent_category_id: this.selectedKey, remark: this.categoryRemark, sequence_no: this.categorySequenceNo, category_settings: JSON.stringify(this.formSettings) } }
      var post_request = await HTTPRequest.postRequest(this.endPoint + 'categories', null, categoryPayload)
      let success = false
      if (post_request == undefined) {
        success = true
        alert("Create Successful")
      } else {
        if (post_request["error"] == undefined) {
          success = true
          alert("Create Successful")
        } else {
          success = false
          this.errors = post_request["error"].split(",")
        }
      }

      if (success == true) {
        switch (this.categoryLevel) {
          case 1:
            var division = await HTTPRequest.getRequest(this.endPoint + "/categories?level=1", null)
            this.divisionList = division
            break;
          case 2:
            this.setDivision(this.divisionId)
            break;
          case 3:
            this.setDepartment(this.departmentId)
            break;
          case 4:
            this.setSection(this.sectionId)
            break;
        }
        this.clearData()
        this.onClose()
      }
    },
    async deleteData (category) {
      this.selectedKey = category.id
      this.categoryLevel = category.level
      if (category.with_children) {
        alert("You cannot delete a parent category.")
      } else {
        var categoryPayload = { category: { status: "D" } }
        await HTTPRequest.destroyRequest(this.endPoint + 'categories/' + this.selectedKey, null, categoryPayload)
        switch (this.categoryLevel) {
          case 1:
            var division = await HTTPRequest.getRequest(this.endPoint + "/categories?level=1", null)
            this.divisionList = division
            break;
          case 2:
            this.setDivision(this.divisionId)
            break;
          case 3:
            this.setDepartment(this.departmentId)
            break;
          case 4:
            this.setSection(this.sectionId)
            break;
        }
        this.clearData()
        alert("Delete Successful")
      }

    },
    async updateData () {
      var categoryPayload = { category: { name: this.categoryName.trim(), code: this.categoryCode.trim(), refcode: this.categoryRefCode ? this.categoryRefCode.trim() : this.categoryRefCode, status: 'A', remark: this.categoryRemark, sequence_no: this.categorySequenceNo, category_settings: JSON.stringify(this.formSettings) } }
      var put_request = await HTTPRequest.putRequest(this.endPoint + 'categories/' + this.selectedKey, null, categoryPayload)
      let success = false
      if (put_request == undefined) {
        success = true
        alert("Update Successful")
      } else {
        if (put_request["error"] == undefined) {
          success = true
          alert("Update Successful")
        } else {
          success = false
          this.errors = put_request["error"].split(",")
        }
      }

      if (success == true) {
        switch (this.categoryLevel) {
          case 1:
            var division = await HTTPRequest.getRequest(this.endPoint + "/categories?level=1", null)
            this.divisionList = division
            break;
          case 2:
            this.setDivision(this.divisionId)
            break;
          case 3:
            this.setDepartment(this.departmentId)
            break;
          case 4:
            this.setSection(this.sectionId)
            break;
        }
        this.clearData()
        this.onClose()
      }
    },
    async downloadCategories () {
      axios({
        url: this.endPoint + "/categories/download",
        method: 'POST',
        responseType: 'blob', // important
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
        }
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'categories.csv');
        document.body.appendChild(link);
        link.click();
        this.successMessage = "Download successful"
      });
    },
    clearData () {
      this.categoryName = null
      this.categoryCode = ""
      this.categoryRefCode = ""
      this.categoryRemark = null
      this.categorySequenceNo = null
      this.formSettings = {}
      this.componentKey++
      this.errors = []
    },
    setParentId (id) {
      this.updateParentId(id)
    },
    changeFilter (statusFilter, searchFilter, searchText) {
      this.setParentId(0);
      this.filterStatus = statusFilter
      if (statusFilter == "0") {
        this.updateParameters("?" + searchFilter + "=" + searchText)
      } else if (statusFilter == "A") {
        this.updateParameters("?" + searchFilter + "=" + searchText + "&status=A")
      } else {
        this.updateParameters("?" + searchFilter + "=" + searchText + "&status=I")
      }
      this.formKey2++;
    },
    changeComboPage: async function (page, pageSize) {
      this.spinning = true
      let combos = await HTTPRequest.getRequest(this.endPoint + `product_combo_groups?page=${page}&per_page=${pageSize}`, null, null)

      this.comboGroupList = combos.data
      this.comboPage = combos.current_page
      this.comboPageSize = combos.per_page
      this.comboTotal = combos.total

      this.comboGroupId = null
      this.comboproductList = null
      this.comboproductId = null

      this.spinning = false
    },
    handleProductSearch: async function (value) {
      let result = await HTTPRequest.getRequest(this.endPoint + `products?name=${value}`, null, null)
      this.productSearchList = result.data
    },
     async showHistoryDrawer(cat) {
      this.historyVisible = true
      var productAttHistory = await HTTPRequest.getRequest(this.endPoint + "category_update_histories?category_id=" + cat.id, null, null);
      this.historyData = productAttHistory;
    },
  }
};
</script>

<style>
.selected2 {
  background-color: #EFF6FF;
  color: #2371CC;
}
</style>
